import script from "./PaywallCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallCharts.vue?vue&type=script&setup=true&lang=js"

import "./PaywallCharts.vue?vue&type=style&index=0&id=36bddd3c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bddd3c"]])

export default __exports__